import { useLocation } from "react-router-dom";
import { continueAuthPath } from "./authReturn";

/** Login/signup href that returns the user to the page they started from. */
export function useAuthEntryPath(authPath: string): string {
  const location = useLocation();
  return continueAuthPath(authPath, location);
}
